import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { CategoryColorNode } from '../components/catalog-graph/CategoryColorNode';
import { CategoryLegend } from '../components/catalog-graph/CategoryLegend';

// The entity-card:catalog-graph/relations extension is disabled by default in
// the new frontend system. It is enabled via app-config.yaml:
//   app.extensions: [entity-card:catalog-graph/relations]
//
// The page override below wraps the plugin's own alpha CatalogGraphPage in a
// div so that the catalog-graph CSS rules in customStyles.css (all scoped to
// .catalog-graph-page-body) continue to apply.
export const catalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [
    catalogGraphPlugin.getExtension('page:catalog-graph').override({
      params: {
        loader: async () => {
          const { CatalogGraphPage } = await import(
            '@backstage/plugin-catalog-graph'
          );
          return (
            <div className="catalog-graph-page-body">
              <div style={{ padding: '0 16px' }}>
                <CategoryLegend />
              </div>
              <CatalogGraphPage renderNode={CategoryColorNode} />
            </div>
          );
        },
      },
    }),
  ],
});
